import edit_button from "../edit_button.html";

export default function (nga, admin) {
  var prices = admin.getEntity("Prices");
  prices
    .listView()
    .title(
      '<h4>Prices <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>'
    )
    .batchActions([])
    .fields([
      nga.field("name", "string").label("App ID"),
      nga.field("price_per_day").cssClasses("hidden-xs").label("Day"),
      nga.field("price_per_month").cssClasses("hidden-xs").label("Month"),
      nga
        .field("price_per_three_months")
        .cssClasses("hidden-xs")
        .label("Three Months"),
      nga
        .field("price_per_six_months")
        .cssClasses("hidden-xs")
        .label("Six Months"),
      nga.field("price_per_year").cssClasses("hidden-xs").label("Year"),

      nga.field("is_default", "boolean").label("Is Default"),
    ])
    .listActions(["edit"])

    .exportFields([prices.listView().fields()]);

  prices
    .creationView()
    .title(
      '<h4>Prices <i class="fa fa-angle-right" aria-hidden="true"></i> Create: PRICE</h4>'
    )
    .fields([
      nga
        .field("name", "string")
        .attributes({ placeholder: "Name" })
        .validation({ required: false })
        .label("Name"),
      nga
        .field("price_per_day")
        .attributes({ placeholder: "Day" })
        .validation({ required: false })

        .label("Price per Day"),
      nga
        .field("price_per_month")
        .attributes({ placeholder: "Month" })
        .validation({ required: false })

        .label("Price per Month"),
      nga
        .field("price_per_three_months")
        .attributes({ placeholder: "Three Months" })
        .validation({ required: false })

        .label("Price per Three Months"),
      nga
        .field("price_per_six_months")
        .attributes({ placeholder: "Six Months" })
        .validation({ required: false })
        .label("Price per Six Months"),
      nga
        .field("price_per_year")
        .attributes({ placeholder: "Year" })
        .validation({ required: false })
        .label("Price per Year"),
      nga
        .field("mrp")
        .attributes({ placeholder: "MRP" })
        .validation({ required: false })
        .label("MRP"),
      nga
        .field("drp")
        .attributes({ placeholder: "DRP" })
        .validation({ required: false })
        .label("DRP"),
      nga
        .field("lco_discount")
        .attributes({ placeholder: "lco discount" })
        .validation({ required: false })
        .label("LCO Discount"),
      nga
        .field("lco_rate")
        .attributes({ placeholder: "lco rate" })
        .validation({ required: false })
        .label("LCO Rate"),
      nga
        .field("is_default", "boolean")
        .attributes({ placeholder: "Is Default" })
        .validation({ required: true })
        .label("Is Default"),

      nga.field("template").label("").template(edit_button),
    ]);

  prices
    .editionView()
    .title(
      '<h4>Prices <i class="fa fa-angle-right" aria-hidden="true"></i> Edit: {{ entry.values.title }}</h4>'
    )
    .actions(["list"])
    .fields([prices.creationView().fields()]);

  return prices;
}



// WEBPACK FOOTER //
// ./js/prices/config.js